var GoeHistoryTableController = (function () {
    function GoeHistoryTableController(topic, moment) {
        this.topic = topic;
        this.moment = moment;
        this.DATE_FORMAT = 'MM/DD/YYYY HH:mm:ss';
        this.TABLE_HEADERS = ['Opportunity', 'Submit Date', 'Expiration Date', 'Country', 'Status/Substatus', 'Account Name', 'Customer Number', 'GOE Decision'];
        if (this.topic.goeHistoryCheck) {
            this.goeHistoryCheck = this.topic.goeHistoryCheck;
        }
    }
    GoeHistoryTableController.prototype.isTableEmpty = function () {
        return !this.goeHistoryCheck || !this.goeHistoryCheck.historyData || this.goeHistoryCheck.historyData.length === 0;
    };
    GoeHistoryTableController.prototype.formatDate = function (date) {
        return this.moment.utc(date).format(this.DATE_FORMAT);
    };
    GoeHistoryTableController.$inject = ['topic', 'moment'];
    return GoeHistoryTableController;
}());
angular
    .module('application')
    .component('eligibilityGoeHistoryTable', new GoeHistoryTableComponent());

//# sourceMappingURL=goeHistoryTableController.js.map
